<template>
  <div class="process-order">
    <div class="loading" v-if="isLoading"></div>
    <template v-else>
      <button
        type="button"
        class="add-to-cart-btn"
        @click.prevent="(event) => processOrderAction(event)"
        v-html="processordertext ? processordertext : $t('labels.processOrder')"
      ></button>
      <span class="or-separator">{{ $t("labels.or") }}</span>
      <button
        type="button"
        class="skip-process-btn"
        @click.prevent="(event) => skipProcessAction(event)"
      >
        {{ $t("labels.skipProcess") }}
      </button>
    </template>
  </div>
</template>

<script>
import CartService from "@/services/cart";
import { useDraftStore } from "@/store/draft";
import ProductService from "@/services/product";
import { useOrderHistoryStore } from "@/store/orderHistory";
import Orion from "@/services/orion";
import { useCartStore } from "@/store/cart";
import Utils from "@/services/utils";
import { constants } from "@/constants";

export default {
  name: "CheckoutButtonProcessOrder",
  props: {
    item: {
      type: Object,
    },
    type: {
      type: String,
      default: "crosssell",
    },
    processordertext: {
      type: String,
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isLoading() {
      return useDraftStore().isSendingDraftOrder;
    },
  },
  methods: {
    async processOrderAction(event) {
      if (this.item) {
        this.item.qtyIncr = 1;
        this.item.choice = ProductService.getDefaultChoice(this.item);
        CartService.addToCart(this.item);

        useDraftStore().sendingDraftOrder(true);
        const previousOrder =
          useOrderHistoryStore().orderHistory.slice(-1)[0].order;

        const newOrder = Object.assign({}, previousOrder);
        newOrder.previousExternalOrderId = previousOrder.externalOrderId;
        newOrder.externalOrderId = Utils.generateUID();

        if (
          this.type === "crosssell" &&
          useDraftStore().initialOrderData?.paymentType ===
            constants.PAYMENT_METHOD_BANK_CARD
        ) {
          newOrder.initialExternalOrderId =
            useDraftStore().initialOrderData.externalOrderId;
          newOrder.isPaymentCaptured = true;
        }

        useDraftStore().updateOrder(newOrder);

        const preparedOrder = Orion.prepareOrder(
          useCartStore().cart,
          newOrder,
          { orderType: this.type },
        );
        useDraftStore().updateOrder(preparedOrder);
        console.log("ProcessOrderPreparedOrder", preparedOrder);

        const minifiedCart = CartService.minifyCart();
        minifiedCart.items.map(
          (item) =>
            (item.choice.configUrl = `${window.location.origin}/data/products/${item.choice.productId}.json`),
        );
        await Orion.sendOrder(
          minifiedCart,
          preparedOrder,
          window.globalConfig.domainId,
          this.type,
        );

        useOrderHistoryStore().addOrderToHistory(
          useCartStore().cart,
          preparedOrder,
          this.step,
        );

        useDraftStore().sendingDraftOrder(false);
        useDraftStore().draftOrderSent(true);

        CartService.emptyCart();

        // Redirect to waiting page with orderId
        const paramPlus = this.buildParamPlus(preparedOrder);
        localStorage.setItem(constants.PARAM_PLUS, JSON.stringify(paramPlus));

        window.location.href = `${window.location.origin}${window.globalConfig.waitingPage}`;
      }
    },
    buildParamPlus(preparedOrder) {
      const paramPlus = {};

      if (window.location.search.length > 0) {
        window.location.search
          .slice(1)
          .split("&")
          .forEach((pair) => {
            const row = pair.split("=");
            paramPlus[row[0]] = row[1];
          });
      }

      paramPlus.orderId = preparedOrder.externalOrderId;
      paramPlus.paymentType = preparedOrder.paymentType;
      paramPlus.action = "capture";
      paramPlus.retryUrl = `${window.location.origin}${window.location.pathname.replace(/\/$/, "")}?retry=${preparedOrder.externalOrderId}`;

      return paramPlus;
    },
    skipProcessAction(event) {
      CartService.addToCartLoading(true);

      useOrderHistoryStore().addStepToHistory();

      CartService.addToCartLoading(false);
    },
  },
};
</script>
